import { render, staticRenderFns } from "./SentimentHot2.vue?vue&type=template&id=2339b24e&scoped=true"
import script from "./SentimentHot2.vue?vue&type=script&lang=js"
export * from "./SentimentHot2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339b24e",
  null
  
)

export default component.exports